import { FC, ReactElement } from 'react';

import { ITeamMemberMapped } from '~/utils/clientAllocation';
import { AllocationMode } from '../../constants/allocationMode';
import { useEditClientAllocationContext } from '../context/EditClientAllocationContext';
import AllocationClientsList from './AllocationsList/AllocationClientsList';
import AllocationLocationGroupsList from './AllocationsList/AllocationLocationGroupsList';
import CrisisAllocationClientsList from './AllocationsList/CrisisAllocationClientsList';
import AllocationClientsListGU from './AllocationsList/AllocationClientsListGU';

interface IProps {
  teamMemberIdx: number;
  teamMember: ITeamMemberMapped;
}

const AssignedClients: FC<IProps> = ({ teamMemberIdx, teamMember }): ReactElement => {
  const { allocationMode, currentUserRole } = useEditClientAllocationContext();

  const clientAllocationList = currentUserRole.isGlobalUser ? (
    <AllocationClientsListGU teamMemberIdx={teamMemberIdx} teamMember={teamMember} />
  ) : (
    <AllocationClientsList teamMemberIdx={teamMemberIdx} teamMember={teamMember} />
  );

  return (
    <>
      <CrisisAllocationClientsList teamMemberIdx={teamMemberIdx} />
      {allocationMode === AllocationMode.BY_LOCATION_GROUP ? (
        <AllocationLocationGroupsList teamMemberIdx={teamMemberIdx} teamMember={teamMember} />
      ) : (
        clientAllocationList
      )}
    </>
  );
};

export default AssignedClients;
